type EnvVars = {
  OWL_CORE_URL: string;
  SIGNALS_API_URL: string;
  VITE_APP_ENV: string;
  VITE_APP_OWL_THIRD_PARTY_URL: string;
};

export const getEnv = (): EnvVars => ({
  OWL_CORE_URL: (import.meta as any).env.VITE_APP_OWL_CORE_URL,
  VITE_APP_OWL_THIRD_PARTY_URL: (import.meta as any).env.VITE_APP_OWL_THIRD_PARTY_URL,
  SIGNALS_API_URL: (import.meta as any).env.VITE_SIGNALS_API_URL,
  VITE_APP_ENV: (import.meta as ImportMeta).env.VITE_APP_ENV
});
